import { useTranslation } from '@frontend/i18n';
import { ProductOnboardingTasks, useProductOnboardingTasks } from '@frontend/product-onboarding-tasks';
import { useModalControl } from '@frontend/design-system';
import { DigitalFormsSetupTaskModal } from './digital-forms-setup-task-modal';
import { digitalFormsTrackingIds } from './digital-forms-tracking-ids';
import { DigitalFormsSetupTaskCardProps } from './types';

const SEND_FORMS_ARTICLE_URL = 'https://www.weavehelp.com/hc/en-us/articles/4710009186203';

export const SendFormLinkTask = ({ taskId }: DigitalFormsSetupTaskCardProps) => {
  const { t } = useTranslation('forms', { keyPrefix: 'digitalFormsSetupTask' });
  const addBookingSiteLinkModal = useModalControl();

  const { updateAndRefetchUserAction } = useProductOnboardingTasks();

  const modalPrimaryButtonClickHandler = () => {
    window.open(SEND_FORMS_ARTICLE_URL, '_blank');
    addBookingSiteLinkModal.closeModal();
  };

  return (
    <>
      <ProductOnboardingTasks.OnboardingTask
        title={t('Send Forms')}
        buttonLabel={t('Start')}
        onButtonClick={addBookingSiteLinkModal.openModal}
        subtitle={t('Weave Help Article')}
        taskId={taskId}
        buttonClickTrackingId={digitalFormsTrackingIds.sendDigitalFormsTaskStartButton}
      />
      <DigitalFormsSetupTaskModal
        title={t('Send Forms')}
        content={t(
          'Once you have created your digital forms and packets you are ready to start sending them out to your patients.'
        )}
        onPrimaryButtonClick={modalPrimaryButtonClickHandler}
        primaryButtonLabel={t('View Weave Help Article')}
        onSecondaryButtonClick={() => updateAndRefetchUserAction({ taskId })}
        primaryButtonTrackingId={digitalFormsTrackingIds.sendFormsViewWeaveHelpArticleLinkButton}
        secondaryButtonTrackingId={digitalFormsTrackingIds.sendDigitalFormsMarkAsComplete}
        {...addBookingSiteLinkModal.modalProps}
      />
    </>
  );
};
